<txtb-drawer
  #drawerComponent
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [groupInfo]="groupInfo"
  [zoomFeatureAvailable]="true"
>
  <article main class="zoom-image">
    <txtb-image-wrapper
      [imageData]="action.meta.image"
      style="height: 100%; width: 100%"
      [scrollDisabled]="(drawerComponent?.drawingByPointerMove$ | async) === true"
      [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
      [percentageScale]="action.meta?.image?.percentageScale || null"
    ></txtb-image-wrapper>
  </article>
</txtb-drawer>
